import React, {useEffect, useState} from 'react';

import '../../../App.css';
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {
    Button,
    Card,
    Checkbox, Empty,
    Flex
} from "antd";
import Title from "antd/es/typography/Title";
import {AIProviderSettings, providers} from "../../../ai/providers/AIProvider";
import {loadAiSettings, loadProjectAiProviders, saveProjectAiProviders} from "../../../feature/project/aiSlice";
import {useParams} from "react-router-dom";
import {saveProjectStorageProvider} from "../../../feature/project/storageSlice";
import {openAccountSettings} from "../../../feature/project/appSettingsSlice";

export const ProjectAiSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const aiProviders = useAppSelector(state => state.aiSlice.aiProviderSettings)
    const projectAiProviders = useAppSelector(state => state.aiSlice.projectAiProviderSettings)
    const [selectedProviders, setSelectedProviders] = useState<AIProviderSettings[]>([])
    const creator = useAppSelector(state => state.users.creator)
    const user = useAppSelector(state => state.users.currentUser)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(loadAiSettings())
        dispatch(loadProjectAiProviders({projectId: projectId}))
        setLoading(false)
    }, []);

    useEffect(() => {
        setSelectedProviders(projectAiProviders)
    }, [projectAiProviders]);

    useEffect(() => {
        props.saveFunction(() => {
            dispatch(saveProjectAiProviders({providers: selectedProviders, projectId: projectId}))
        })
    }, [selectedProviders]);

    return (
        <Flex gap={10} vertical={true}>
            <Title level={5} style={{margin: 0, paddingTop: 10}}>AI Settings</Title>
            {user?.id != creator?.id ?
                <div>You are not a creator of this project, you can not change AI Settings of the project.<br/><br/>Contact a
                    creator <b>{creator?.email}</b> of the project to enable or disable AI Providers.</div>
                : <>
                    Select AI providers you want to use for this project. If you don't see providers you want, please
                    check
                    global settings or if you are not an owner of the project ask project owner to enable providers you
                    need.
                    {aiProviders.filter(provider => provider.enabled).length > 0 ?
                        aiProviders.filter(provider => provider.enabled).map(provider =>
                            <Card
                                key={provider.name}
                                style={{cursor: 'pointer'}}
                                onClick={(e) => {
                                    selectedProviders.map(p => p.name).includes(provider.name) ? setSelectedProviders(selectedProviders.filter(p => p.name != provider.name)) : setSelectedProviders(selectedProviders.concat(provider))
                                }}
                            >
                                <Flex gap={10} align={'center'}>
                                    <Checkbox
                                        style={{alignItems: 'center'}}
                                        checked={
                                            selectedProviders.map(p => p.name).includes(provider.name)
                                        }
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            selectedProviders.map(p => p.name).includes(provider.name) ? setSelectedProviders(selectedProviders.filter(p => p.name != provider.name)) : setSelectedProviders(selectedProviders.concat(provider))
                                        }}
                                    >
                                    </Checkbox>
                                    <Flex
                                        align={'center'}
                                        gap={10}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            selectedProviders.map(p => p.name).includes(provider.name) ? setSelectedProviders(selectedProviders.filter(p => p.name != provider.name)) : setSelectedProviders(selectedProviders.concat(provider))
                                        }}>
                                        {providers.find(p => p.name == provider.name)?.icon}<b>{provider.name}</b>
                                    </Flex>
                                </Flex>
                            </Card>
                        ) : <Empty description={<>Enable at least one AI Provider in the <Button
                            size={'small'}
                            onClick={() => dispatch(openAccountSettings('ai'))}
                        >Account Settings
                        </Button></>}/>
                    }</>}
        </Flex>
    );
};
